export const SAMPLE_GRID_ROUTE = "/dashboard/samples/sample";
export const SURVEY_GRID_ROUTE = "/dashboard/samples/survey";
